import { render, staticRenderFns } from "./RadioWork.vue?vue&type=template&id=06422a58&"
import script from "./RadioWork.vue?vue&type=script&lang=js&"
export * from "./RadioWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports